<template>
  <div class="box">
    <!-- 图片 -->
    <div>
      <!-- <img
        :src="require('../../src/assets/image/1.jpg')"
        v-for="item of 6"
        :key="item"
      /> -->
      <img :src="item" alt="" v-for="(item,index) in imgs" :key="index" />
    </div>
    <!-- <img src="../../assets/image/1.jpg" alt=""> -->
  </div>
</template>

<script>
export default {
  name: "rotate3d",
  data() {
    return {
      imgs: [
        "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3302399998,3216746631&fm=26&gp=0.jpg",
        "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=280591509,585529894&fm=26&gp=0.jpg",
        "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=280591509,585529894&fm=26&gp=0.jpg",
        "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=341802306,419856862&fm=26&gp=0.jpg",
      ],
    };
  },
  methods: {
    rotate() {
      this.$(function () {
        var imgL = this.$(".box div").size();
        console.log(imgL);
        var deg = 360 / (imgL - 1);
        //注意这边是遍历，别忘记i
        this.$(".box div").each(function (i) {
          this.$(this).css({
            // <!--translateZ 定义2d旋转沿着z轴-->
            transform: "rotateY(" + i * deg + "deg) translateZ(2 3.9vw)",
          });
          // <!--防止图片被拖拽-->
          this.$(this).attr("ondragstart", "return false");
        });
      });
    },
  },
};
</script>

<style lang='less' scoped>
//   body {
//     background-color: #fff;
//   }

/* 动画  沿着X轴倾斜-15deg，动画沿着Y轴旋转 */
@keyframes rotate3d {
  0% {
    transform: rotateX(-15deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-15deg) rotateY(360deg);
  }
}

@-moz-keyframes rotate3d {
  0% {
    transform: rotateX(-15deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-15deg) rotateY(360deg);
  }
}

@-ms-keyframes rotate3d {
  0% {
    transform: rotateX(-15deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-15deg) rotateY(360deg);
  }
}

@-webkit-keyframes rotate3d {
  0% {
    transform: rotateX(-15deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-15deg) rotateY(360deg);
  }
}

/* 动画加给了父盒子 */
.box {
  width: 10.41vw;
  height: 15.62vw;
  position: relative;
  margin: auto;
  margin-top: 7.81vw;
  transform-style: preserve-3d;
  transform: rotateX(-10deg);
  animation: rotate3d 10s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
//   position: relative;
  display: flex;
  flex-flow: row nowrap;
  > div {
      background: #f00;
    width: 10.41vw;
    height: 15.62vw;
    // position: absolute;
    left: 0;
    top: 0;
    img {
      width: 10.41vw;
      height: 15.62vw;
    }
  }
}

/* 鼠标滑过，停止旋转*/
.box:hover {
  animation-play-state: paused;
}
</style>


// WEBPACK FOOTER //
// src/components/common/rotate3d.vue